import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, StateDto, Miniature } from '../../../models';
import { groupRulesRemoveState, groupRulesAddState } from '../../../common';
import { IStateService } from '../../../services';

interface IStateFormController extends angular.IFormController {
    nameProperty: angular.INgModelController;
}

interface IWtGroupRulesContextualContoller {
    states: StateDto[];
    onlyAttached: boolean;
}

class GroupRulesContextualController implements IWtGroupRulesContextualContoller {
    widgetsMiniature: Miniature[];
    states: StateDto[];
    formController: IStateFormController;
    onlyAttached = false;

    private _allStates: StateDto[];
    private _usedStates: StateDto[];
    private _groupGuid: string;
    private _watchers: Function[];

    static $inject = ['$stateParams', '$rootScope', 'stateService'];

    constructor(private _$stateParams: angular.ui.IStateParamsService,
        private _$rootScope: angular.IRootScopeService,
        private _stateService: IStateService) {
    }

    $onInit() {
        this._groupGuid = this._$stateParams['groupGuid'];
        this._stateService.getAll().then((states) => {
            this._allStates = states;
            return this._stateService.getUsedByGroup(this._groupGuid);
        }).then(states => {
            this._usedStates = states;
            this.refresh();
        });

        this._watchers = [
            this._$rootScope.$on(groupRulesAddState, (_event, data) => {
                this._stateService.getByGuid(data.itemId).then(state => {
                    this._usedStates.push(state);
                    this.refresh();
                });
            }),
            this._$rootScope.$on(groupRulesRemoveState, (_event, data) => {
                _.remove(this._usedStates, (s) => s.state.guid === data);
                this.refresh();
            })
        ];
    }

    $onDestroy() {
        try {
            if (this._watchers && this._watchers.length) {
                this._watchers.forEach(w => w());
            }
        } catch (e) {
            console.error(e);
        }
    }

    private refresh() {
        this.states = this._allStates.filter((s) => {
            const result = _.some(this._usedStates, state => state.state.guid === s.state.guid);
            return (this.onlyAttached) ? result : !result;
        });
    }
}

export const wtGroupRulesContextual: ComponentDefinition = {
    componentId: 'wtGroupRulesContextual',
    controller: GroupRulesContextualController,
    template: require('./groupRulesContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=?',
        onlyAttached: '@'
    }
};